import React, { useContext } from "react";
// Custom Fields Provider

import { createContext, useState, ReactNode } from "react";

// Types
interface FieldsDrawer {
  type: string;
  show: boolean;
}

interface CustomFieldsContextType {
  createdFields: any;
  setCreatedFields: React.Dispatch<React.SetStateAction<any>>;
  toggleCustomFieldDrawer: (type?: string, show?: boolean) => void;
  toggleCustomFieldModal: (hasValue?: boolean) => void;
  fieldsDrawer: FieldsDrawer;
  createFieldModal: boolean;
  toggleConfirmModal: (hasValue?: boolean) => void;
  confirmModal: boolean;
}

interface CustomFieldsProviderProps {
  children: ReactNode;
}

export const CustomFieldsContext =
  createContext<CustomFieldsContextType | null>(null);

const CustomFieldsProvider: React.FC<CustomFieldsProviderProps> = ({
  children,
}) => {
  const [createdFields, setCreatedFields] = useState<any>(null);
  const [fieldsDrawer, setFieldsDrawer] = useState<FieldsDrawer>({
    type: "",
    show: false,
  });
  const [createFieldModal, setCreateFieldModal] = useState<boolean>(false);
  const [confirmModal, setConfirmModal] = useState<boolean>(false);

  const toggleCustomFieldDrawer = (type: string = "", show?: boolean) =>
    setFieldsDrawer({ type: type, show: show || false });

  const toggleCustomFieldModal = (hasValue?: boolean) =>
    setCreateFieldModal(hasValue ? hasValue : false);

  const toggleConfirmModal = (hasValue?: boolean) =>
    setConfirmModal(hasValue || false);

  return (
    <CustomFieldsContext.Provider
      value={{
        createdFields,
        setCreatedFields,
        toggleCustomFieldDrawer,
        toggleCustomFieldModal,
        fieldsDrawer,
        createFieldModal,
        toggleConfirmModal,
        confirmModal,
      }}>
      {children}
    </CustomFieldsContext.Provider>
  );
};

export default CustomFieldsProvider;

export const useCustomFields = () => {
  const context = useContext(CustomFieldsContext);
  if (!context) {
    throw new Error(
      "useCustomFields must be used within a CustomFieldsProvider"
    );
  }
  return context;
};
